import type { FetchResponse } from '@sydle/ui-api';
import { CustomAPI, DefaultRestService, setAPI } from '@sydle/ui-api';
import { setLoading } from '../utils/loading.utils';
import { anonymousRestService } from './anonymousRestService';
import { attendTask } from './attendTask';
import { availablesCatalogs } from './availablesCatalogs';
import { changePassword } from './changePassword';
import { closeTicket } from './closeTicket';
import { executeAction } from './executeAction';
import { executeMethod } from './executeMethod';
import { getAlerts } from './getAlerts';
import { getCardsListData } from './getCardsListData';
import { getChat } from './getChat';
import { getChildren } from './getChildren';
import { getFavoriteItems } from './getFavoriteItems';
import { getImage } from './getImage';
import { getInternationalizedContent } from './getInternationalizedContent';
import { getItem } from './getItem';
import { getItemIcon } from './getItemIcon';
import { getLeafs } from './getLeafs';
import { getListData } from './getListData';
import { getSectionContent } from './getSectionContent';
import { getSortedChildren } from './getSortedChildren';
import { getTags } from './getTags';
import { getTicket } from './getTicket';
import { getTicketComments } from './getTicketComments';
import { getTree } from './getTree';
import { getUserTask } from './getUserTask';
import { isFavorite } from './isFavorite';
import { postComment } from './postComment';
import { recoverPassword } from './recoverPassword';
import { registerRating } from './registerRating';
import { search } from './search';
import { toggleFavorite } from './toggleFavorite';
import { validadeToken } from './validadeToken';
import { cancelTicket } from './cancelTicket';

const portalAPI = {
  changePassword,
  recoverPassword,
  validadeToken,
  executeMethod,
  attendTask,
  getAlerts,
  availablesCatalogs,
  getChildren,
  getFavoriteItems,
  getSortedChildren,
  getSectionContent,
  search,
  getTicket,
  getChat,
  closeTicket,
  executeAction,
  toggleFavorite,
  isFavorite,
  getTicketComments,
  postComment,
  registerRating,
  getImage,
  getItem,
  getTree,
  getLeafs,
  getTags,
  getInternationalizedContent,
  getCardsListData,
  getListData,
  getUserTask,
  getItemIcon,
  cancelTicket,
};

class PortalCustomAPI extends CustomAPI {
  async fetch<T = unknown, K = unknown>(methodIdentifier: string, body: T): Promise<FetchResponse<K>> {
    setLoading(true);

    return super
      .fetch<T, K>(methodIdentifier, body)
      .then()
      .finally(() => setLoading(false));
  }
}

export const PORTAL_API_CLASS_ID = '5cd5e83d59f8170cd4dc2c43';

export const portalCustomAPI = new PortalCustomAPI(
  PORTAL_API_CLASS_ID,
  new DefaultRestService({}, { additionalParams: { suppressAlerts: true } }),
);
export const portalAnonymousCustomAPI = new PortalCustomAPI(PORTAL_API_CLASS_ID, anonymousRestService);

/**
 * Utility function that defines Service Desk API as property of Window.
 */
export function createPortalAPI(): void {
  setAPI<PortalAPI>('portalAPI', portalAPI);
}

export type PortalAPI = typeof portalAPI;
